export const APP_STORE_URL = 'https://apps.apple.com/app/id6786507441';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.voicenote.ai';

export function openAppStore() {
  const ua = navigator.userAgent;
  const url = /android/i.test(ua) ? PLAY_STORE_URL : APP_STORE_URL;
  window.open(url, '_blank', 'noopener,noreferrer');
}
